var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"emailWrapper",on:{"click":_vm.select}},[_c('div',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.iconImage)}}),_c('p',{staticClass:"email",domProps:{"innerHTML":_vm._s(_vm.email)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }